import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GET, POST, PUT, DELETE } from '../../services/api';
import { Navigate } from 'react-router';

// Add Celebrity Category
export const addCelebrityCategory = createAsyncThunk(
  'celebrityCategory/add',
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST('/admin/celebrity', data);
      if (response?.status === 200) {
        return response.data.result;
      } else {
        return rejectWithValue(response?.data || 'Something went wrong');
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to add category');
    }
  }
);

// List Celebrity Categories
export const listCelebrityCategory = createAsyncThunk(
  'celebrityCategory/list',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await GET('/admin/celebrity', {...params});
      if (response?.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response?.data || 'Something went wrong');
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to fetch categories');
    }
  }
);

// View Celebrity Category
export const viewCelebrityCategory = createAsyncThunk(
  'celebrityCategory/view',
  async (categoryId, { rejectWithValue }) => {
    try {
      const response = await GET(`/admin/celebrity/view`, { celebrity_id: categoryId });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'An error occurred');
    }
  }
);

// Update Celebrity Category
export const updateCelebrityCategory = createAsyncThunk(
  'celebrityCategory/update',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await PUT(`/admin/celebrity?celebrity_id=${id}`, data);
      if (response?.status === 200) {
        
        return response.data.result;
      } else {
        return rejectWithValue(response?.data || 'Something went wrong');
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to update category');
    }
  }
);

// Delete Celebrity Category
export const deleteCelebrityCategory = createAsyncThunk(
  'celebrityCategory/delete',
  async (id, { rejectWithValue }) => {
    try {
      const response = await DELETE(`/admin/celebrity`, { celebrity_id: id });
      if (response?.status === 200) {
        return response.data.result;
      } else {
        return rejectWithValue(response?.data || 'Something went wrong');
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to delete category');
    }
  }
);

const CelebrityCategorySlice = createSlice({
  name: 'celebrityCategory',
  initialState: {
    addCategory: [],
    addCategoryLoading: false,
    addCategoryError: null,
    listCategory: [],
    listCategoryCount: '',
    listCategoryLoading: false,
    listCategoryError: null,
    viewCategory: [],
    viewCategoryLoading: false,
    viewCategoryError: null,
    updateCategory: [],
    updateCategoryLoading: false,
    updateCategoryError: null,
    deleteCategory: [],
    deleteCategoryLoading: false,
    deleteCategoryError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

    .addCase(viewCelebrityCategory.pending, (state) => {
        state.viewCategoryLoading = true;
        state.viewCategoryError = null;
      })
      .addCase(viewCelebrityCategory.fulfilled, (state, action) => {
        state.viewCategoryLoading = false;
        state.viewCategory = action.payload.result;
      })
      .addCase(viewCelebrityCategory.rejected, (state, action) => {
        state.viewCategoryLoading = false;
        state.viewCategoryError = action.error.message;
      })

      .addCase(addCelebrityCategory.pending, (state) => {
        state.addCategoryLoading = true;
        state.addCategoryError = null;
      })
      .addCase(addCelebrityCategory.fulfilled, (state, action) => {
        state.addCategoryLoading = false;
        state.addCategory = action.payload;
      })
      .addCase(addCelebrityCategory.rejected, (state, action) => {
        state.addCategoryLoading = false;
        state.addCategoryError = action.error.message;
      })
      .addCase(listCelebrityCategory.pending, (state) => {
        state.listCategoryLoading = true;
        state.listCategoryError = null;
      })
      .addCase(listCelebrityCategory.fulfilled, (state, action) => {
        state.listCategoryLoading = false;
        state.listCategory = action.payload?.result?.rows;
        state.listCategoryCount = action.payload?.result?.count;
      })
      .addCase(listCelebrityCategory.rejected, (state, action) => {
        state.listCategoryLoading = false;
        state.listCategoryError = action.error.message;
      })
      .addCase(updateCelebrityCategory.pending, (state) => {
        state.updateCategoryLoading = true;
        state.updateCategoryError = null;
      })
      .addCase(updateCelebrityCategory.fulfilled, (state, action) => {
        state.updateCategoryLoading = false;
        state.updateCategory = action.payload;
      })
      .addCase(updateCelebrityCategory.rejected, (state, action) => {
        state.updateCategoryLoading = false;
        state.updateCategoryError = action.error.message;
      })
      .addCase(deleteCelebrityCategory.pending, (state) => {
        state.deleteCategoryLoading = true;
        state.deleteCategoryError = null;
      })
      .addCase(deleteCelebrityCategory.fulfilled, (state, action) => {
        state.deleteCategoryLoading = false;
        state.deleteCategory = action.payload;
      })
      .addCase(deleteCelebrityCategory.rejected, (state, action) => {
        state.deleteCategoryLoading = false;
        state.deleteCategoryError = action.error.message;
      });
  },
});

export default CelebrityCategorySlice.reducer;
